/* INTEGY V682 — final authoritative status/count guard for oversized collection owners.
 * Purpose: keep the settled large-owner count/status aligned with URL page state after
 * legacy observers or deferred collection scripts run. Does not change products, stock,
 * sorting, pagination membership, or URLs.
 */
(function () {
  'use strict';
  if (window.IntegyV682LargeStatusGuard) return;

  var ROOT = document.documentElement;
  var scheduled = false;
  var writing = false;

  function params() {
    try { return new URLSearchParams(location.search || ''); }
    catch (error) { return new URLSearchParams(); }
  }

  function clearanceSoldOutActive() {
    if (!document.body || !document.body.classList.contains('template-collection')) return false;
    if (!/\/collections\/on-sale-clearance-up-to-80(?:\/|$)/.test(location.pathname)) return false;
    var p = params();
    return p.get('integy_stock') === 'out';
  }

  function ownedGrid() {
    return document.querySelector('[data-integy-v681-authoritative-owner], [data-integy-v651-large-owner="true"]');
  }

  function visibleCards(grid) {
    if (!grid) return 0;
    return Array.prototype.slice.call(grid.querySelectorAll('[data-product-item],.productgrid--item')).filter(function (card) {
      if (!card || card.hidden || card.getAttribute('aria-hidden') === 'true') return false;
      try { return getComputedStyle(card).display !== 'none'; } catch (error) { return true; }
    }).length;
  }

  function sync() {
    scheduled = false;
    if (writing || !clearanceSoldOutActive()) return;
    var grid = ownedGrid();
    if (!grid) return;

    var total = Number(grid.getAttribute('data-integy-v651-large-total') || 0);
    if (!(total > 0)) return;

    var page = Math.max(1, parseInt(params().get('page') || '1', 10) || 1);
    var pages = Math.max(1, Math.ceil(total / 72));
    if (page > pages) page = pages;

    var expectedVisible = Math.max(0, Math.min(72, total - ((page - 1) * 72)));
    var actualVisible = visibleCards(grid);
    var visible = actualVisible || expectedVisible;
    // The owner's grid is authoritative. On the final page prefer the mathematically exact
    // remainder if a secondary observer temporarily counts a duplicated/transition card.
    if (page === pages && expectedVisible > 0) visible = expectedVisible;

    var statusText = 'Showing ' + visible + ' of ' + total + ' sold-out ' + (total === 1 ? 'product' : 'products') +
      (pages > 1 ? ' — page ' + page + ' of ' + pages : '');
    var countText = total + ' sold-out ' + (total === 1 ? 'product' : 'products');

    writing = true;
    Array.prototype.forEach.call(document.querySelectorAll('[data-integy-v449-stock-status],[data-integy-v548-stock-status]'), function (node) {
      if (node.textContent !== statusText) node.textContent = statusText;
      node.setAttribute('data-integy-v682-authoritative-status', 'true');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.collection--product-count,.productgrid--count,.integy-collection-meta .integy-chip,[data-integy-collection-product-count]'), function (node) {
      if (!node || (!/products?|checking|refreshing|found/i.test(node.textContent || '') && !node.hasAttribute('data-integy-collection-product-count'))) return;
      if (node.textContent !== countText) node.textContent = countText;
      node.setAttribute('data-integy-v682-authoritative-count', 'true');
    });
    grid.setAttribute('data-integy-v682-page', String(page));
    grid.setAttribute('data-integy-v682-pages', String(pages));
    grid.setAttribute('data-integy-v682-visible', String(visible));
    writing = false;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(sync, 0);
  }

  function boot() {
    if (!clearanceSoldOutActive()) return;
    schedule();
    [80, 250, 700, 1500].forEach(function (delay) { setTimeout(sync, delay); });
    document.addEventListener('integy:v681:large-stock-ready', schedule);
    window.addEventListener('popstate', function () { setTimeout(sync, 0); });
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        if (writing) return;
        var relevant = mutations.some(function (m) {
          var t = m.target && m.target.nodeType === 1 ? m.target : m.target && m.target.parentElement;
          return t && t.closest('[data-integy-v449-stock-status],[data-integy-v548-stock-status],.collection--product-count,.productgrid--count,[data-productgrid-items],.productgrid--items');
        });
        if (relevant) schedule();
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class','hidden','aria-hidden','data-integy-v651-large-total','data-integy-v681-authoritative-owner'] });
    }
    ROOT.classList.add('integy-v682-status-guard-ready');
  }

  window.IntegyV682LargeStatusGuard = { sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
